




















































































import {ratingApi} from '@/api/RatingApi';
import {tournamentsApi} from '@/api/TournamentsApi';
import {filterMatchColumns} from '@/helpers';
import {asyncScheduler, from, combineLatest, of, merge} from 'rxjs';
import {
  filter,
  switchMap,
} from 'rxjs/operators';
import {reportsService} from '@/services/ReportsService';
import {HeroesVersion} from '@/api/HeroesVersion';
import {Vue, Prop, Component} from 'vue-property-decorator';
import UserLinks from '../../components/common/UserLinks.vue';
import BlankLoader from '../../components/common/BlankLoader.vue';
import QuickAccess from '../../components/rating/QuickAccess.vue';
import DataFilter from '../../components/common/DataFilter.vue';
import DataTable from '../../components/common/DataTable.vue';
import CollapsibleTable from '../../components/common/CollapsibleTable.vue';
import {
  generateLangSubscriptions,
  observeFieldAsUIInput,
  observeProp,
  observeRouteParam,
  watchAsLoadedObservable,
} from '@/components/observe';
import {Route} from 'vue-router';

@Component<RatingTableView>({
  components: {
    UserLinks,
    BlankLoader,
    QuickAccess,
    DataFilter,
    DataTable,
    CollapsibleTable,
  },
  subscriptions() {
    const $route$ = observeProp<Route>(this, '$route');
    const lang$ = observeRouteParam<string>($route$, 'lang');
    const allPlayersMode$ = observeProp(this, 'allPlayersMode');

    const unconfirmedReports$ = lang$.pipe(
      switchMap((lang) => from(reportsService.getUnconfirmedReports(HeroesVersion.Heroes3, lang), asyncScheduler)),
    );
    const userInfo$ = from(tournamentsApi.getCurrentTournamentUserInfo$(), asyncScheduler);

    return Object.assign(generateLangSubscriptions(lang$), {
      userInfo: userInfo$,
      activePlayersStartTime: from(ratingApi.getLatestRatingStartTime$(), asyncScheduler),
      allPlayersRoute: combineLatest(
        allPlayersMode$,
        lang$,
      ).pipe(
        switchMap(([mode, lang]: any) => of({
          name: mode ? 'home' : 'rating_all',
          params: {lang},
        })),
      ),
      ratingInfoTitle: combineLatest(
        observeProp(this, 'translate'),
        allPlayersMode$,
      ).pipe(
        filter(([translate]: any) => !!translate),
        switchMap(([translate, mode]: any) => of(mode ? translate.rating_info_all : translate.rating_info)),
      ),
      ratingLastUpdate: from(ratingApi.getRatingLastUpdate$(), asyncScheduler),
      rating: combineLatest(
        allPlayersMode$.pipe(
          switchMap((allPlayersMode: any) => from(ratingApi.getRating$(allPlayersMode), asyncScheduler)),
        ),
        unconfirmedReports$,
        observeFieldAsUIInput(this, 'ratingFilter'),
        userInfo$,
      ).pipe(
        switchMap(([ratings, unconfirmedReports, ratingFilter]: any) => of(ratings
          .filter((x: any) => this.filterMatch(x, ratingFilter))
          .map((x: any) => Object.assign(x, {
            has_unconfirmed_reports: unconfirmedReports
              .some((y: any) => y.player1_id === x.user_id || y.player2_id === x.user_id),
          })))),
      ),
      isRatingLoaded: merge(
        watchAsLoadedObservable(this, 'rating'),
        allPlayersMode$.pipe(switchMap(() => of(false))),
      ),
    });
  },
})
export default class RatingTableView extends Vue {
  public columns = [
    {name: 'number', title: 'number', width: '4%'},
    {name: 'player', title: 'player', width: '18%'},
    {name: 'victories', title: 'victories', width: '13%'},
    {name: 'defeats', title: 'defeats', width: '13%'},
    {name: 'draws', title: 'draws', width: '13%'},
    {name: 'games', title: 'games', width: '13%'},
    {name: 'rating', title: 'rating', width: '13%'},
    {name: 'win_rate', title: 'win_rate', width: '13%'},
  ];
  public columnClasses = [
    {name: 'number', class: 'rating-table-number'},
    {name: 'player', class: 'rating-table-player'},
    {name: 'victories', class: 'rating-table-victories'},
    {name: 'defeats', class: 'rating-table-defeats'},
    {name: 'draws', class: 'rating-table-draws'},
    {name: 'games', class: 'rating-table-games'},
    {name: 'rating', class: 'rating-table-rating'},
    {name: 'win_rate', class: 'rating-table-win_rate'},
  ];
  public ratingFilter = '';

  @Prop() public allPlayersMode!: boolean;

  public filterMatch(rating: any, ratingFilter: string) {
    return filterMatchColumns(rating, ratingFilter, [
      'username',
      'def_count',
      'lose_count',
      'draw_count',
      'games_count',
      'rating',
      'win_rate',
    ]);
  }
}
